import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
const puntos = ['No necesitás experiencia previa', 'Materiales fáciles de conseguir', 'Patrones listos para imprimir', 'Para regalar, decorar o vender'];
export function Identificacion() {
  return <section className="w-full bg-crema py-10 sm:py-14" aria-labelledby="identificacion-titulo" data-id="element-98" data-mp="1cn9q99ptt4va">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-99" data-mp="ezj8wj72rjlw">
        <Reveal data-id="element-100" data-mp="f142o6lkeyip">
          <h2 id="identificacion-titulo" className="text-center font-serif text-2xl leading-snug text-borgona sm:text-3xl" data-id="element-101" data-mp="exg771wk821c">
            Podés empezar hoy, aunque nunca hayas bordado
          </h2>
        </Reveal>

        <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-102" data-mp="ovvxj2nrj79s">
          {puntos.map((punto, index) => <Reveal key={punto} delay={0.05 * index} data-id="element-103" data-mp="tqibndl8bdxk" data-mpi={index}>
              <li className="flex h-full items-center gap-3 rounded-2xl border border-rosa-100 bg-white px-4 py-3" data-id="element-104" data-mp="3sf7bmoa8kwho">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-oliva/15 text-oliva" data-id="element-105" data-mp="16tim2kijsiz">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-106" data-mp="1xsd7bgrnpigl" />
                </span>
                <span className="font-sans text-base font-semibold leading-snug text-tinta" data-id="element-107" data-mp="1srxuqrf78ezo">
                  {punto}
                </span>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}